module.exports = __webpack_public_path__ + "img/factura1.ea428863.png";